import { Auth } from "aws-amplify";
import { jwtDecode, JwtPayload } from "jwt-decode";

type JwtPayloadWithAzureType = JwtPayload & {
  at_hash?: string;
};

export const getJwtToken = async (): Promise<string> => {
  const session = await Auth.currentSession();

  return session.getAccessToken().getJwtToken();
};

export const getIdToken = async (): Promise<string> => {
  const session = await Auth.currentSession();

  return session.getIdToken().getJwtToken();
};

export async function getIdTokenData() {
  const idToken = await getIdToken();
  const decoded: JwtPayloadWithAzureType = jwtDecode(idToken);

  return decoded;
}
